module.exports = __webpack_public_path__ + "static/media/16.9b940bb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/16.jpg
// module id = 385
// module chunks = 0